import { Box, Button, ButtonProps, Typography, styled } from "@mui/material";
import { IProfileState } from "../../../../store/profileSlice";
import { useAppSelector } from "../../../../hooks/hooks";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const StyledLink = styled(Link)`
  text-decoration: none;
  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;

const StyledButton = styled(Button)<
  ButtonProps & { component: React.ElementType }
>`
  &:hover {
    color: white;
    text-decoration: none;
    background-color: #503dfc;
    box-shadow: none;
  }
`;

interface HeaderProps {
  openDrawer: () => void;
  openModalFunction: () => void;
}

const ReceivableHeader: React.FC<HeaderProps> = ({
  openDrawer,
  openModalFunction,
}) => {
  const data = useSelector((state: any) => state.receivable);

  const profile: IProfileState = useAppSelector((state) => state.profileSlice);

  return (
    <Box display={"flex"}>
      <Box>
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: 24,
          }}
          color="inherit"
          noWrap
        >
          Vendas e simulação
        </Typography>
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: 16,
            color: "#8087A6",
          }}
          color="inherit"
          noWrap
        >
          Importe suas notas fiscais para simular gratuitamente a antecipação de
          parcelas/recebíveis.
        </Typography>
      </Box>
      <Box
        sx={{
          flexGrow: 1,
        }}
      />
      <Box display={"flex"} padding={"5 0"} alignItems={"center"}>
        <Button
          onClick={openDrawer}
          variant="outlined"
          color="secondary"
          sx={{
            mr: "24px",
            px: "16px",
            py: "10px",
          }}
        >
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: 14,
            }}
            color="inherit"
            noWrap
          >
            Importar Notas Fiscais
          </Typography>
        </Button>

        {profile.profile?.subscription?.cashAdvanceEnabled ? (
          <StyledButton
            sx={{
              textTransform: "none",
              borderRadius: 50,
              px: "16px",
              py: "10px",
              boxShadow: "none",
              "&.Mui-disabled": {
                background: "#E7E7E7",
                color: "#BCBCBC",
              },
            }}
            type="submit"
            disabled={!data.length}
            variant="contained"
            component={StyledLink}
            {...(data.length !== 0 && { to: "credit" })}
            onClick={() => {
              openDrawer();
              if (data.length === 0) {
                toast.warning("Selecione pelo menos uma nota");
              }
            }}
          >
            <Typography
              sx={{ fontWeight: 500, fontSize: 14 }}
              color="inherit"
              noWrap
            >
              Simular selecionados
            </Typography>
          </StyledButton>
        ) : (
          <Button
            sx={{ px: "16px", py: "10px" }}
            variant="contained"
            color="primary"
            disabled={!data.length}
            onClick={openModalFunction}
          >
            <Typography
              sx={{ fontWeight: 500, fontSize: 14 }}
              color="inherit"
              noWrap
            >
              Simular selecionados
            </Typography>
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default ReceivableHeader;
